__turbopack_context__.v({
  "hr": "winners-module__oN7wAW__hr",
  "introArea": "winners-module__oN7wAW__introArea",
  "pagingContainerItems": "winners-module__oN7wAW__pagingContainerItems",
  "pagingControls": "winners-module__oN7wAW__pagingControls",
  "pagingNext": "winners-module__oN7wAW__pagingNext",
  "pagingPageCount": "winners-module__oN7wAW__pagingPageCount",
  "pagingPrevious": "winners-module__oN7wAW__pagingPrevious",
  "pinnedCarousel": "winners-module__oN7wAW__pinnedCarousel",
  "playButton": "winners-module__oN7wAW__playButton",
  "sectionImage": "winners-module__oN7wAW__sectionImage",
  "spotlightCarousel": "winners-module__oN7wAW__spotlightCarousel",
  "spotlightImageContainer": "winners-module__oN7wAW__spotlightImageContainer",
  "spotlightImageGroupContainer": "winners-module__oN7wAW__spotlightImageGroupContainer",
  "spotlightImageText": "winners-module__oN7wAW__spotlightImageText",
  "wallOfFameCarousel": "winners-module__oN7wAW__wallOfFameCarousel",
  "wallOfFameImageContainer": "winners-module__oN7wAW__wallOfFameImageContainer",
  "wallOfFameImagePairContainer": "winners-module__oN7wAW__wallOfFameImagePairContainer",
  "youtubeContainer": "winners-module__oN7wAW__youtubeContainer",
});
